import React, { Component } from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { ConfigProvider } from "antd";
import locale from "antd/es/locale/zh_CN";
import "moment/locale/zh-cn";
import routerMap from "./routerMap";
import FrontendAuth from "./FrontendAuth";

class App extends Component {
	render() {
		return (
			<ConfigProvider locale={locale}>
				<Router>
					<Switch>
						<FrontendAuth routerConfig={routerMap} />
					</Switch>
				</Router>
			</ConfigProvider>
		);
	}
}
export default App;
